import React from "react";
import { useCurrency } from "../../context-v2/CurrencyContext";

/**
 * Reusable Currency Display Component
 * Automatically updates when currency changes via useCurrency context
 *
 * @param {Object} props
 * @param {number|string} props.amount - The amount to display (optional)
 * @param {boolean} props.symbolOnly - If true, only shows the symbol (default: false)
 * @param {string} props.className - Additional CSS classes
 * @param {React.CSSProperties} props.style - Inline styles
 */
const CurrencyDisplay = ({
  amount,
  symbolOnly = false,
  className = "",
  style = {}
}) => {
  const { currency, formatAmount } = useCurrency();

  if (symbolOnly) {
    return (
      <span className={className} style={style}>
        {currency.symbol}
      </span>
    );
  }

  if (amount !== undefined && amount !== null && amount !== "") {
    return (
      <span className={className} style={style}>
        {formatAmount(amount, true)}
      </span>
    );
  }

  return (
    <span className={className} style={style}>
      {currency.symbol}
    </span>
  );
};

export default CurrencyDisplay;
